import { render, staticRenderFns } from "./SharingLinkPopover.vue?vue&type=template&id=1cbfa5a4&"
import script from "./SharingLinkPopover.vue?vue&type=script&lang=js&"
export * from "./SharingLinkPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports